// Lot SR du chantier 0.5.x (revue par métier du 2026-10-01, manque 7 : SM-19, PO-19) — client de
// `GET /api/v1/search` (RechercheController). Objet séparé de `api` (comme `coeurAgileApi`) : la
// surface figée de `api/client` ne change pas.
import { request } from './http'

/** Types d'objets cherchés, dans l'ordre d'affichage par défaut de la passerelle. */
export type TypeObjet =
  | 'item' | 'defect' | 'test_case' | 'test_campaign' | 'requirement' | 'adr'
  | 'release' | 'deployment' | 'mission' | 'sprint' | 'program' | 'project'

export interface ObjetTrouve {
  type: TypeObjet
  /** Identifiant de l'objet (numérique rendu en texte, UUID, ou identifiant métier). */
  id: string
  /** Identifiant AFFICHÉ (#12, ANO-3, TC-…, NFR-…, ADR-0001, 1.1.0, début d'UUID) ; null sinon. */
  reference: string | null
  title: string
  status: string | null
  /** Précision propre au type : nature, gravité, dates du sprint, version d'un déploiement (id). */
  detail: string | null
  /** Portée d'une exigence ou d'une ADR : workspace/project, program, organisation, tool. */
  scope: string | null
  workspace_id: string | null
  workspace_name: string | null
  program_id: string | null
  program_name: string | null
}

export interface GroupeTrouve {
  type: TypeObjet
  /** Plus de résultats que la limite par type : affiner la recherche. */
  truncated: boolean
  best_rank: number
  results: ObjetTrouve[]
}

export interface ReponseRecherche {
  query: string
  limit: number
  total: number
  /** Un ou plusieurs types n'ont pas pu être lus : les autres sont rendus. */
  partial: boolean
  failed_types: TypeObjet[]
  groups: GroupeTrouve[]
}

/** Bornes de la passerelle (RechercheObjetsService). */
export const RECHERCHE_LONGUEUR_MAX = 100
export const RECHERCHE_LONGUEUR_MIN_TEXTE = 2

export const rechercheApi = {
  rechercher: (q: string, init?: { signal?: AbortSignal; limit?: number }) => {
    const params = new URLSearchParams({ q })
    if (init?.limit != null) params.set('limit', String(init.limit))
    return request<ReponseRecherche>(`/search?${params.toString()}`, init?.signal ? { signal: init.signal } : undefined)
  },
}
